module.exports = __webpack_public_path__ + "public/img/Menggunakan Bahasa Inggris Bagi Calon Sekretaris.45ff012d.png";